import "core-js/modules/es7.object.values";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartBar',
  props: {
    value: Object,
    text: String,
    subtext: String
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var xAxisData = Object.keys(_this.value);
      var seriesData = Object.values(_this.value);
      var option = {
        title: {
          text: _this.text,
          subtext: _this.subtext,
          x: 'center'
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: seriesData,
          type: 'bar'
        }]
      };
      _this.dom = echarts.init(_this.$refs.dom, 'tdTheme');

      _this.dom.setOption(option);

      on(window, 'resize', _this.resize);
    });
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};